<script lang="ts">
  import AdminView from './AdminView.svelte';
  import Block from './Block.svelte';
  
  export let props: any = null;
  export let adminView = false;
  export let dataElement = undefined;
</script>

{#if adminView}
  <AdminView {props} />
{:else}
  <Block {props} {dataElement} />
{/if}
